import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { TuiDayRange } from '@taiga-ui/cdk';
import { PreviousRouteService } from '@src/core/services';

@Component({
  selector: 'lp-statistics-header',
  templateUrl: './lp-statistics-header.component.html',
  styleUrls: ['./lp-statistics-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpStatisticsHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() periodVisible = true;
  @Output() changPeriod = new EventEmitter<TuiDayRange | null>();

  period: TuiDayRange | null = null;

  private readonly previousRouteService = inject(PreviousRouteService);

  onClickBackButton() {
    this.previousRouteService.back('/loyalty');
  }
}
